<template>
  <div id="queryBuilderContainer">
    <query-builder
      header-title="Edit DMS Query"
      :query-id="this.$route.params.id"
      :is-template="true"
      v-on:save="handleSave"
    />
  </div>
</template>

<script>
import QueryBuilder from './QueryBuilder'
export default {
  components: {
    QueryBuilder
  },
  methods: {
    handleSave (datasource) {
      this.$router.push({ name: 'dms_datasources_path' })
      this.$flash({
        showClose: true,
        message: `Saved Dms Datasource ${datasource.name}`,
        type: 'success',
        duration: 2000
      })
    }
  }
}
</script>

<style>
</style>
